import { Link } from "@tanstack/react-router";
import { siteConfig } from "@/config";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-border bg-muted/30">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <div className="text-lg font-bold text-foreground">{siteConfig.siteName}</div>
            <p className="mt-1 max-w-md text-sm text-muted-foreground">
              {siteConfig.description}
            </p>
          </div>
          <nav className="flex flex-wrap gap-4 text-sm" aria-label="Footer">
            <Link to="/" className="text-muted-foreground hover:text-primary">Home</Link>
            <Link to="/privacy-policy" className="text-muted-foreground hover:text-primary">Privacy Policy</Link>
            <Link to="/terms-condition" className="text-muted-foreground hover:text-primary">Terms</Link>
            <Link to="/contact-us" className="text-muted-foreground hover:text-primary">Contact</Link>
          </nav>
        </div>
        <div className="mt-8 border-t border-border pt-6 text-center text-xs text-muted-foreground">
          © {year} {siteConfig.siteName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
